import BaseListPresenter from "../../../../base/BaseListPresenter";
import { v4 as uuidv4 } from "uuid";
import { findObjectUseCase } from "../../../../usecases/object";

export default class NegativeRecordsListPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    upsertUseCase,
    deleteObjectUseCase,
  ) {
    super(
      view,
      findObjectUseCase,
      countObjectUseCase,
      upsertUseCase,
      deleteObjectUseCase,
    );
    this.upsertUseCase = upsertUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
  }

  componentDidMount() {
    this.init();
    this.getAffialiateOutSide();
    this.getUserAffBranch();
    this.getUser();
    // this.getAccessRequest();
    this.getObjects();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: {
        ...this.where,
        ...this.search,
        ...this.filter,
        ...this.filterDate,
      },

      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  // createQuery() {
  //   const skip = (this.current - 1) * this.limit;

  //   // Helper function to escape special regex characters
  //   const escapeRegex = (str) => {
  //     return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  //   };

  //   // Convert search strings to regex for flexible matching
  //   const searchWithRegex = {};
  //   if (this.search) {
  //     Object.keys(this.search).forEach((key) => {
  //       if (this.search[key]) {
  //         searchWithRegex[key] = {
  //           $regex: escapeRegex(this.search[key]),
  //           $options: "i",
  //         };
  //       }
  //     });
  //   }

  //   const query = {
  //     limit: this.limit,
  //     skip: skip,
  //     where: {
  //       ...this.where,
  //       ...searchWithRegex,
  //       ...this.filter,
  //       ...this.filterDate,
  //     },
  //     include: this.include,
  //   };

  //   if (this.sort) {
  //     query.sort = this.sort;
  //   }

  //   const keys = this.keys || this.view.getKeys() || [];
  //   if (keys.length > 0) {
  //     query.keys = keys;
  //   }

  //   return query;
  // }

  // async findObjects() {
  //   if (Object.keys(this.search).length === 0) {
  //     this.objects = [];
  //     this.hideProgress();
  //     return;
  //   }

  //   const collection = this.view.getCollectionName();
  //   const query = this.createQuery();
  //   console.log("send query", query);
  //   try {
  //     this.showProgress();
  //     this.findObjectUseCase.abort();
  //     const objects = await this.findObjectUseCase.execute(collection, query);
  //     console.log("ob", objects);

  //     this.objects = this.objects.concat(objects);
  //     this.view.setTotal(this.objects.length);
  //     this.view.setObjects(this.objects);
  //     this.hideProgress();
  //   } catch (error) {
  //     this.hideProgress();
  //     this.view.showError(error);
  //   }
  //   this.progress = false;
  // }

  //   async getAffialiateOutSide() {
  //   const collection = "affiliates";
  //   const query = {
  //     where: {
  //       group: "OUTSIDE",
  //       isShowOutSide: true,
  //     },
  //   };

  //   try {
  //     const response = await findObjectUseCase().execute(collection, query);
  //     this.view.setOutSideClient(response);
  //   } catch (error) {}
  // }

  async findObjects() {
    if (Object.keys(this.search).length === 0) {
      this.objects = [];
      this.hideProgress();
      return;
    }

    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    const currentUser = this.view.getCurrentUser();

    // query.where = {
    //   ...query.where,
    //   firstName: query.where.firstName || "",
    //   middleName: query.where.middleName || "",
    //   lastName: query.where.lastName || "",
    //   alias: query.where.alias || "",
    // };
    const where = { ...query.where };

    const addIfPresent = (key) => {
      const val = query.where[key];
      if (val) {
        where[key] = val;
      } else {
        delete where[key]; // don't filter on empty fields
      }
    };

    ["firstName", "middleName", "lastName", "alias"].forEach(addIfPresent);

    query.where = where;

    // console.log("qqqq", query);

    this.showProgress();
    this.progress = true;
    this.findObjectUseCase.abort();

    try {
      // 1) primary lookup
      let primaryResults = await this.findObjectUseCase.execute(
        collection,
        query,
        {
          timeout: 120000,
        },
      );
      console.log("primary results", primaryResults);

      // const searchQuery = {
      //   where: {
      //     firstName: query.where.firstName,
      //     middleName: query.where.middleName,
      //     lastName: query.where.lastName,
      //     alias: query.where.alias,
      //   },
      // };
      // const searchQuery = {
      //   where: {
      //     firstName: query.where.firstName || "",
      //     middleName: query.where.middleName || "",
      //     lastName: query.where.lastName || "",
      //     alias: query.where.alias || "",
      //   },
      // };
      const searchQuery = {
        where: {
          ...(query.where.firstName && { firstName: query.where.firstName }),
          ...(query.where.middleName && { middleName: query.where.middleName }),
          ...(query.where.lastName && { lastName: query.where.lastName }),
          ...(query.where.alias && { alias: query.where.alias }),
        },
      };
      // const searchQuery = {
      //   where: {
      //     firstName: query.where.firstName || "",
      //     middleName: query.where.middleName || "",
      //     lastName: query.where.lastName || "",
      //     alias: query.where.alias ? query.where.alias : { $in: ["", null] }, // matches empty string OR null
      //   },
      // };

      // 2) fallback lookup from search_logs/no_records
      console.log("fall query", query);
      let fallbackResults = [];
      // if (!Array.isArray(primaryResults) || primaryResults.length === 0) {
      fallbackResults = await this.findObjectUseCase.execute(
        "no_records",
        query,
      );
      console.log("fallback results", fallbackResults);
      // }
      // console.log("primary", primaryResults);
      // console.log("fall", fallbackResults);
      // 3) merge both result sets
      const allResults = [
        ...(Array.isArray(primaryResults) ? primaryResults : []),
        ...(Array.isArray(fallbackResults) ? fallbackResults : []),
      ];

      // 4) update the view
      this.objects = allResults;

      // console.log("allResults", allResults);
      this.view.setTotal(this.objects.length);
      this.view.setObjects(this.objects);
    } catch (error) {
      this.view.showError(error);
    } finally {
      this.hideProgress();
      this.progress = false;
    }
  }

  // async findObjects() {
  //   if (Object.keys(this.search).length === 0) {
  //     this.objects = [];
  //     this.hideProgress();
  //     return;
  //   }

  //   const collection = this.view.getCollectionName();
  //   const query = this.createQuery();
  //   const currentUser = this.view.getCurrentUser();

  //   console.log("qqqq", query);

  //   this.showProgress();
  //   this.progress = true;
  //   this.findObjectUseCase.abort();

  //   try {
  //     // 1) primary lookup
  //     let primaryResults = await this.findObjectUseCase.execute(
  //       collection,
  //       query,
  //       {
  //         timeout: 120000,
  //       }
  //     );
  //     console.log("primary results", primaryResults);

  //     const searchQuery = {
  //       where: {
  //         firstName: query.where.firstName,
  //         middleName: query.where.middleName,
  //         lastName: query.where.lastName,
  //       },
  //     };

  //     // 2) ALWAYS query fallback to get additional results
  //     let fallbackResults = await this.findObjectUseCase.execute(
  //       "no_records",
  //       searchQuery
  //     );
  //     console.log("fallback results", fallbackResults);

  //     // 3) merge BOTH result sets
  //     const allResults = [
  //       ...(Array.isArray(primaryResults) ? primaryResults : []),
  //       ...(Array.isArray(fallbackResults) ? fallbackResults : []),
  //     ];

  //     // 4) optionally remove duplicates if needed (based on unique id)
  //     // const uniqueResults = allResults.filter((obj, index, self) =>
  //     //   index === self.findIndex(o => o.id === obj.id)
  //     // );

  //     // 5) update the view
  //     this.objects = allResults;
  //     this.view.setTotal(this.objects.length);
  //     this.view.setObjects(this.objects);
  //   } catch (error) {
  //     this.view.showError(error);
  //   } finally {
  //     this.hideProgress();
  //     this.progress = false;
  //   }
  // }

  // async findObjects() {
  //   if (Object.keys(this.search).length === 0) {
  //     this.objects = [];
  //     this.hideProgress();
  //     return;
  //   }

  //   const collection = this.view.getCollectionName();
  //   const query = this.createQuery();
  //   const currentUser = this.view.getCurrentUser();

  //   console.log("qqqq", query);

  //   this.showProgress();
  //   this.progress = true;
  //   this.findObjectUseCase.abort();

  //   try {
  //     // 1) primary lookup
  //     let results = await this.findObjectUseCase.execute(collection, query, {
  //       timeout: 120000,
  //     });
  //     console.log("reslt", results);

  //     const searchQuery = {
  //       where: {
  //         firstName: query.where.firstName,
  //         middleName: query.where.middleName,
  //         lastName: query.where.lastName,
  //       },
  //     };

  //     // // 2) if primary returned nothing, fall back to search_logs
  //     if (!Array.isArray(results) || results.length === 0) {
  //       results = await this.findObjectUseCase.execute(
  //         "no_records",
  //         searchQuery
  //       );
  //     }

  //     // // 3) merge into your master list
  //     this.objects = this.objects.concat(results);
  //     this.view.setTotal(this.objects.length);
  //     this.view.setObjects(this.objects);
  //   } catch (error) {
  //     this.view.showError(error);
  //   } finally {
  //     this.hideProgress();
  //     this.progress = false;
  //   }
  // }

  async onClickView(index) {
    const object = this.objects[index];

    // console.log("ob", object);

    if (object.lockedTo?.id === null) {
      object.lockedTo.id = "";
    }

    // ADD ACCESS HISTORY
    const currentUser = this.view.getCurrentUser();
    const accessObject = {
      accessor: { id: currentUser.id },
      // record: { id: object?.searchNameId },
      record: { id: object?.searchNameId ?? object?.id },
    };

    // console.log("acc", accessObject);

    await this.upsertUseCase.execute("access_history", accessObject);

    this.view.navigateTo(object.id);
  }

  async searchSubmit(search) {
    // console.log("search", search);
    const currentUser = this.view.getCurrentUser();
    const affiliateId = currentUser?.affiliate?.id;
    const [affiliate] = await this.findObjectUseCase.execute("affiliates", {
      where: { id: affiliateId },
    });
    const isPrepaid = affiliate?.billingType === "Prepaid";

    // Build trimmed search query - store SIMPLE STRINGS only
    const searchQuery = {};
    if (search.firstName) searchQuery.firstName = search.firstName.trim();
    if (search.middleName) searchQuery.middleName = search.middleName.trim();
    if (search.lastName) searchQuery.lastName = search.lastName.trim();
    if (search.alias) searchQuery.alias = search.alias.trim();

    this.showProgress();
    this.reset();
    this.search = searchQuery; // Store simple strings here

    // Check for recent (within 24h) log
    const recentLog = await this.getRecentSearchLog(affiliateId, search);

    if (!recentLog) {
      if (isPrepaid) {
        const [credits] = await this.findObjectUseCase.execute("credits", {
          where: { "client.id": affiliateId },
        });

        // console.log("cc", credits);

        // if (credits.status === "Inactive") {
        //   this.view.showError(
        //     "Client is inactive. Please contact admin.",
        //     "Error",
        //   );
        //   this.hideProgress();
        //   return;
        // }

        if (!credits || credits.balance <= 0) {
          this.view.showError("No balance. Please contact admin.", "Error");
          this.hideProgress();
          return;
        }

        credits.balance -= 1;
        await this.upsertUseCase.execute("credits", credits);
      }

      await this.addSearchLog(search);
    } else {
      this.view.setSearchLog(recentLog);
    }

    await this.findObjects();
    this.view.setSearchStatus("searched");
    this.hideProgress();
    this.view.setState({ searchBtnDisabled: false });
  }

  // async searchSubmit(search) {
  //   console.log("search", search);
  //   const currentUser = this.view.getCurrentUser();
  //   const affiliateId = currentUser?.affiliate?.id;

  //   const [affiliate] = await this.findObjectUseCase.execute("affiliates", {
  //     where: { id: affiliateId },
  //   });

  //   const isPrepaid = affiliate?.billingType === "Prepaid";

  //   // Build trimmed search query
  //   // const searchQuery = {};
  //   // if (search.firstName) searchQuery.firstName = search.firstName.trim();
  //   // if (search.middleName) searchQuery.middleName = search.middleName.trim();
  //   // if (search.lastName) searchQuery.lastName = search.lastName.trim();
  //   // if (search.alias) searchQuery.alias = search.alias.trim();

  //   // Build search query with regex for flexible matching
  //   const searchQuery = {};

  //   if (search.firstName) {
  //     const trimmedFirst = search.firstName.trim();
  //     searchQuery.firstName = {
  //       $regex: trimmedFirst,
  //       $options: "i", // case-insensitive
  //     };
  //   }

  //   if (search.middleName) {
  //     const trimmedMiddle = search.middleName.trim();
  //     searchQuery.middleName = {
  //       $regex: trimmedMiddle,
  //       $options: "i",
  //     };
  //   }

  //   if (search.lastName) {
  //     const trimmedLast = search.lastName.trim();
  //     searchQuery.lastName = {
  //       $regex: trimmedLast,
  //       $options: "i",
  //     };
  //   }

  //   if (search.alias) {
  //     searchQuery.alias = {
  //       $regex: search.alias.trim(),
  //       $options: "i",
  //     };
  //   }

  //   this.showProgress();
  //   this.reset();
  //   this.search = searchQuery;

  //   // Check for recent (within 24h) log
  //   const recentLog = await this.getRecentSearchLog(affiliateId, search);

  //   if (!recentLog) {
  //     // ✅ Deduct credits ONLY IF not found in last 24 hours
  //     if (isPrepaid) {
  //       const [credits] = await this.findObjectUseCase.execute("credits", {
  //         where: { "client.id": affiliateId },
  //       });

  //       if (!credits || credits.balance <= 0) {
  //         this.view.showError("No balance. Please contact admin.", "Error");
  //         this.hideProgress();
  //         return;
  //       }

  //       credits.balance -= 1;
  //       await this.upsertUseCase.execute("credits", credits);
  //     }

  //     // Log the search
  //     await this.addSearchLog(search);
  //   } else {
  //     this.view.setSearchLog(recentLog);
  //   }

  //   await this.getObjects();
  //   this.view.setSearchStatus("searched");
  //   this.hideProgress();
  //   this.view.setState({ searchBtnDisabled: false });
  // }

  // async getRecentSearchLog(affiliateId, search) {
  //   const logs = await this.findObjectUseCase.execute("search_logs", {
  //     where: {
  //       searcher: { affiliate: { id: affiliateId } },
  //       searched_first_name: search.firstName,
  //       searched_middle_name: search.middleName,
  //       searched_last_name: search.lastName,
  //       searched_alias: search.alias,
  //     },
  //     // sort: { createdAt: -1 },
  //   });

  //   logs.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

  //   const latestLog = logs[0];

  //   console.log("LATEST", latestLog);

  //   if (!latestLog) return null;

  //   const now = new Date();
  //   const logTime = new Date(latestLog.createdAt);
  //   const diffHours = (now - logTime) / (1000 * 60 * 60); // milliseconds to hours

  //   return diffHours <= 24 ? latestLog : null;
  // }

  // async searchSubmit(search) {
  //   console.log("search", search);
  //   const currentUser = this.view.getCurrentUser();
  //   console.log("user", currentUser);
  //   const response = await this.findObjectUseCase.execute("affiliates", {
  //     where: { id: currentUser.affiliate?.id },
  //   });
  //   console.log("Prepaid affi", response);

  //   if (response[0]?.billingType === "Prepaid") {
  //     const responseCredits = await this.findObjectUseCase.execute("credits", {
  //       where: { "client.id": currentUser.affiliate?.id },
  //     });
  //     console.log("hey", responseCredits);

  //     const updateCredits = responseCredits[0];

  //     if (!updateCredits || updateCredits.balance <= 0) {
  //       this.view.showError("No balance. Please contact admin.", "Error");
  //       return; // ❗ Exit early
  //     }

  //     updateCredits.balance -= 1;

  //     console.log("update", updateCredits);

  //     await this.upsertUseCase.execute("credits", updateCredits);

  //     const searchQuery = {};

  //     if (search.firstName) searchQuery.firstName = search.firstName.trim();
  //     if (search.middleName) searchQuery.middleName = search.middleName.trim();
  //     if (search.lastName) searchQuery.lastName = search.lastName.trim();
  //     if (search.alias) searchQuery.alias = search.alias.trim();

  //     this.showProgress();
  //     this.reset();
  //     this.search = searchQuery;

  //     // CHECK IF KEYWORD IS ALREADY SEARCHED
  //     const [searched] = await this.findObjectUseCase.execute("search_logs", {
  //       where: {
  //         searcher: { affiliate: { id: currentUser?.affiliate?.id } },
  //         searched_first_name: search.firstName,
  //         searched_middle_name: search.middleName,
  //         searched_last_name: search.lastName,
  //         searched_alias: search.alias,
  //       },
  //       include: ["searcher.affiliate"],
  //     });
  //     console.log("search match", searched);

  //     if (!searched) {
  //       // PUSH NEW SEARCH LOG
  //       await this.addSearchLog(search);
  //     } else {
  //       console.log("sss", searched);
  //       this.view.setSearchLog(searched);
  //     }

  //     // GET NEW OBJECTS
  //     await this.getObjects();
  //     this.view.setSearchStatus("searched");
  //     this.hideProgress();
  //   } else {
  //     const searchQuery = {};

  //     if (search.firstName) searchQuery.firstName = search.firstName.trim();
  //     if (search.middleName) searchQuery.middleName = search.middleName.trim();
  //     if (search.lastName) searchQuery.lastName = search.lastName.trim();
  //     if (search.alias) searchQuery.alias = search.alias.trim();

  //     this.showProgress();
  //     this.reset();
  //     this.search = searchQuery;

  //     // CHECK IF KEYWORD IS ALREADY SEARCHED
  //     const [searched] = await this.findObjectUseCase.execute("search_logs", {
  //       where: {
  //         searcher: { affiliate: { id: currentUser?.affiliate?.id } },
  //         searched_first_name: search.firstName,
  //         searched_middle_name: search.middleName,
  //         searched_last_name: search.lastName,
  //         searched_alias: search.alias,
  //       },
  //       include: ["searcher.affiliate"],
  //     });
  //     console.log("search match", searched);

  //     if (!searched) {
  //       // PUSH NEW SEARCH LOG
  //       await this.addSearchLog(search);
  //     } else {
  //       console.log("sss", searched);
  //       this.view.setSearchLog(searched);
  //     }

  //     // GET NEW OBJECTS
  //     await this.getObjects();
  //     this.view.setSearchStatus("searched");
  //     this.hideProgress();
  //   }
  // }

  // const searchQuery = {
  //   firstName: { $regex: search.firstName, $options: "i" },
  //   middleName: { $regex: search.middleName, $options: "i" },
  //   lastName: { $regex: search.lastName, $options: "i" },
  //   alias: { $regex: search.alias, $options: "i" },
  // };

  // const searchQuery = {};

  // if (search.firstName) searchQuery.firstName = search.firstName.trim();
  // if (search.middleName) searchQuery.middleName = search.middleName.trim();
  // if (search.lastName) searchQuery.lastName = search.lastName.trim();
  // if (search.alias) searchQuery.alias = search.alias.trim();

  // this.showProgress();
  // this.reset();
  // this.search = searchQuery;

  // // CHECK IF KEYWORD IS ALREADY SEARCHED
  // const [searched] = await this.findObjectUseCase.execute("search_logs", {
  //   where: {
  //     searcher: { affiliate: { id: currentUser?.affiliate?.id } },
  //     searched_first_name: search.firstName,
  //     searched_middle_name: search.middleName,
  //     searched_last_name: search.lastName,
  //     searched_alias: search.alias,
  //   },
  //   include: ["searcher.affiliate"],
  // });
  // console.log("search match", searched);

  // if (!searched) {
  //   // PUSH NEW SEARCH LOG
  //   await this.addSearchLog(search);
  // } else {
  //   console.log("sss", searched);
  //   this.view.setSearchLog(searched);
  // }

  // // GET NEW OBJECTS
  // await this.getObjects();
  // this.view.setSearchStatus("searched");
  // this.hideProgress();

  async getRecentSearchLog(affiliateId, search) {
    const logs = await this.findObjectUseCase.execute("search_logs", {
      where: {
        searcher: { affiliate: { id: affiliateId } },
        searched_first_name: search.firstName,
        searched_middle_name: search.middleName,
        searched_last_name: search.lastName,
        searched_alias: search.alias,
      },
    });

    logs.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    const latestLog = logs[0];
    if (!latestLog) return null;

    const now = new Date();
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(now.getMonth() - 1); // ✅ accurately subtracts 1 calendar month

    const logTime = new Date(latestLog.createdAt);

    return logTime >= oneMonthAgo ? latestLog : null;
  }

  async addSearchLog(searched) {
    const currentUser = this.view.getCurrentUser();

    // Fetch the last saved record to determine the next referenceNo
    const lastLog = await this.findObjectUseCase.execute("search_logs", {
      orderBy: { created_at: "desc" },
      limit: 1,
    });

    // Extract year and the last reference number, if available
    const currentYear = new Date().getFullYear();
    let nextReferenceNo = `${currentYear}-0000000001`; // Default referenceNo

    if (lastLog && lastLog.length > 0) {
      const lastReferenceNo = lastLog[0].referenceNo;
      const lastYear = lastReferenceNo.split("-")[0];

      if (lastYear === currentYear.toString()) {
        // Increment the last reference number by 1
        const lastNumber = parseInt(lastReferenceNo.split("-")[1], 10);
        const newNumber = lastNumber + 1;
        nextReferenceNo = `${currentYear}-${newNumber
          .toString()
          .padStart(10, "0")}`;
      }
    }

    const newLog = {
      searcher: { id: currentUser.id },
      searched_first_name: searched.firstName,
      searched_middle_name: searched.middleName,
      searched_last_name: searched.lastName,
      searched_alias: searched.alias,
      referenceNo: nextReferenceNo, // Add the new referenceNo
      // new
      // lockedTo: { id: currentUser?.id },
    };

    try {
      const log = await this.upsertUseCase.execute("search_logs", newLog);
      const [affiliate] = await this.findObjectUseCase.execute("affiliates", {
        where: { id: log.searcher.affiliate?.id },
      });
      this.view.setSearchLog({ ...log, affiliateName: affiliate?.name });
    } catch (error) {
      this.view.showError(error);
    }
  }

  async deductCredit(credit) {
    try {
      const newCredit = {
        ...credit,
        balance: credit.balance - 1,
      };

      await this.upsertUseCase.execute("credits", newCredit);
    } catch (error) {
      this.view.showError(error);
    }
  }

  async getAffialiateOutSide() {
    const collection = "affiliates";
    const query = {
      where: {
        group: "OUTSIDE",
        isShowOutSide: true,
      },
    };

    try {
      const response = await findObjectUseCase().execute(collection, query);
      this.view.setOutSideClient(response);
    } catch (error) {}
  }

  async getUserAffBranch() {
    const currentUser = this.view.getCurrentUser();

    try {
      const getUserAffBranch = await findObjectUseCase().execute("users", {
        where: { id: currentUser.id },
        include: ["all"],
      });

      this.view.setUserAffBranch(getUserAffBranch);
      // console.log("gets", getUserAffBranch);
    } catch (error) {
      console.log(error);
    }
  }

  async getUser() {
    const user = this.view.getCurrentUser();
    const collection = "users";
    const query = {
      where: {
        id: user.id,
      },
      include: ["affiliate", "branch"],
    };

    try {
      const response = await findObjectUseCase().execute(collection, query);
      this.view.setUser(response);
    } catch (error) {}
  }

  async onClickSaveNoRecord(searched) {
    const currentUser = this.view.getCurrentUser();

    const outside = this.view.state.outSideClient;
    const outsideName = outside.map((out) => out.name);
    console.log("presenter", outsideName);

    const financeCompanies = outsideName;

    // const financeCompanies = [
    //   // "GLOBAL SME",
    //   // "WISEFUND FINANCE CORPORATION",
    //   // "GLOBAL DOMINION FINANCE INCORPORATED",
    //   // "ASIALINK FINANCE CORPORATION",
    //   // "AFC 2ND HAND CAR LOAN",
    //   // "AFC TRUCK LOAN",
    //   // "CEPAT KREDIT INC.",
    //   // "SOUTHASIALINK FINANCE CORP",
    //   // "SOUTHASIALINK MBL",
    //   // "SOUTHASIALINK CREDIT CORP",
    //   // "SOUTHASIALINK SPECIAL ACCOUNTS",
    //   // "ANNAPOLIS FINANCE INC",
    //   // "GLOBAL CEBUANA FINANCE INC",
    //   // "CEBUANA CYCLE FINANCING INC.",
    //   "AVVANZ PHILIPPINES",
    //   "LENDELL OUTSOURCING SOLUTIONS INC.",
    //   "Lendell Outsourcing Solutions, Inc",
    //   "ABUEMP",
    //   "ABU-EMP",
    //   "1 PENTAGON AND CREDIT LENDING CORPORATION",
    //   "1-PENTAGON CREDIT AND LENDING CORPORATION",
    //   "GLOBAL 8 FINANCE",
    //   "GLOBAL8 FINANCE INC",
    //   "Q2",
    //   "QUAERITO QUALITAS INC.",
    //   "VANGUARD SCREENING SOLUTION INC",
    //   "VANGUARD COLLECTION MANAGEMENT INC.",
    //   "STANDARD INSURANCE",
    //   "Standard Insurance",
    // ];

    const notUnlock = await findObjectUseCase().execute("users", {
      where: { id: currentUser.id },
      include: ["all"],
    });

    const userName = notUnlock?.[0]?.affiliate?.name;
    console.log("financeCompanies", financeCompanies);

    const isFinance = financeCompanies.includes(userName);

    const saveNoRecord = {
      // searcher: { id: currentUser.id },
      firstName: searched.searched_first_name,
      middleName: searched.searched_middle_name,
      lastName: searched.searched_last_name,
      alias: searched.searched_alias,
      searchNameId: uuidv4(),
      // referenceNo: nextReferenceNo, // Add the new referenceNo
      // new
      lockedTo: { id: currentUser?.id },
      noRecord: true,
      lockedDate: new Date().toISOString(),
      specificDateLocked: new Date().toISOString(),
    };
    console.log("saveNoRecord", saveNoRecord);

    console.log("isFinance", isFinance);
    try {
      if (!isFinance) {
        await this.upsertUseCase.execute("no_records", saveNoRecord);
      }
    } catch (error) {}
  }
}
